module.exports = __webpack_public_path__ + "static/media/payu.237042e1.svg";